'use strict';

var React = require('react');

var SvgArrowsOutHorizontalIcon = function SvgArrowsOutHorizontalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 8a.75.75 0 0 0 0-1.5h-7.19l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.5a.75.75 0 0 1 0-1.5h7.19l-1.22-1.22a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-7.19Z"
  }));
};
SvgArrowsOutHorizontalIcon.displayName = "ArrowsOutHorizontalIcon";

exports.SvgArrowsOutHorizontalIcon = SvgArrowsOutHorizontalIcon;
